module.exports = __webpack_public_path__ + "static/media/szlogo_felso.06ea9b68.jpg";